// import React, { useState, useEffect } from 'react';
// import './Transcript.css';

// const TransDash = () => {
//     const [startDate, setStartDate] = useState('');
//     const [endDate, setEndDate] = useState('');
//     const [transcriptdata, setTranscriptData] = useState([]);
//     const [isLoading, setIsLoading] = useState(false);
//     const [submittedRange, setSubmittedRange] = useState(null);
//     const [showModal, setShowModal] = useState(false);
//     const [currentTranscript, setCurrentTranscript] = useState('');
//     const [currentSessionid, setcurrentSessionid] = useState('');

//     useEffect(() => {
//         const handleScroll = () => {
//             const footer = document.querySelector('footer');
//             if ((window.innerHeight + window.scrollY) >= document.body.offsetHeight) {
//                 footer.style.display = 'block';
//             } else {
//                 footer.style.display = 'none';
//             }
//         };

//         window.addEventListener('scroll', handleScroll);
//         return () => {
//             window.removeEventListener('scroll', handleScroll);
//         };
//     }, []);

//     const fetchFeedbackData = async (start, end) => {
//         setIsLoading(true);
//         try {
//             const response = await fetch(`/api/feedback`, {
//                 method: 'POST',
//                 headers: {
//                     'Content-Type': 'application/json',
//                 },
//                 body: JSON.stringify({ start, end }),
//             });
//             const result = await response.json();
//             setTranscriptData(result.transcript);
//         } catch (error) {
//             console.error('Error fetching data:', error);
//         } finally {
//             setIsLoading(false);
//         }
//     };

//     const formatTextWithBold = (text) => {
//         const boldedText = text.replace(/\*\*(.*?)\*\*/g, (match, p1) => `<strong>${p1}</strong>`);
//         const withParagraphs = boldedText.replace(/\n\n/g, '</p><p>');
//         const formattedText = withParagraphs.replace(/\n/g, '<br />');
//         return `<p>${formattedText}</p><br><br>`;
//     };

//     const handleSubmitDateRange = async () => {
//         if (startDate && endDate) {
//             console.log(`Fetching feedback from ${startDate} to ${endDate}`);
//             setSubmittedRange(`${startDate} - ${endDate}`);
//             fetchFeedbackData(startDate, endDate);
//         } else {
//             alert('Please select both start and end dates.');
//         }
//     };

//     useEffect(() => {
//         if (startDate && endDate) {
//             handleSubmitDateRange();
//         }
//     }, [startDate, endDate]);

//     const handleShowTranscript = (transcript, sessionid) => {
//         setCurrentTranscript(transcript);
//         setcurrentSessionid(sessionid)
//         setShowModal(true);
//     };

//     const handleCloseModal = () => {
//         setShowModal(false);
//     };

//     return (
//         <>
//             <h1 style={{ textAlign: "center", fontSize: "2rem", color: "#333", marginBottom: "20px", marginTop: "20px" }}>Transcript Dashboard</h1>
//             <div className="container">
//                 <div className="datepickercontainer">
//                     <div className="date-picker">
//                         <div className="startdate">
//                             <label htmlFor="start-date-picker">Start date:</label>
//                             <input
//                                 type="date"
//                                 id="start-date-picker"
//                                 name="start-date-picker"
//                                 value={startDate}
//                                 onChange={(e) => setStartDate(e.target.value)}
//                             />
//                         </div>
//                         <div className="enddate">
//                             <label htmlFor="end-date-picker">End date:</label>
//                             <input
//                                 type="date"
//                                 id="end-date-picker"
//                                 name="end-date-picker"
//                                 value={endDate}
//                                 onChange={(e) => setEndDate(e.target.value)}
//                             />
//                         </div>
//                     </div>
//                 </div>
//                 {isLoading && <p>↺</p>}
//                 <div className="feedbacks">
//                     <div className="feedbackscontents">
//                         <h2>Transcript</h2>
//                         {submittedRange && <p>{submittedRange}</p>}
//                         <div className="table-container">
//                             <table className="feedback-table">
//                                 <thead>
//                                     <tr>
//                                         <th>Date</th>
//                                         <th>Username</th>
//                                         <th>Email</th>
//                                         <th>Transcript</th>
//                                     </tr>
//                                 </thead>
//                                 <tbody>
//                                     {transcriptdata.length > 0 ? (
//                                         transcriptdata.map((trans, index) => (
//                                             <tr key={index}>
//                                                 <td>{trans.date}</td>
//                                                 <td>{trans.name}</td>
//                                                 <td>{trans.emailID}</td>
//                                                 <td>
//                                                     <button onClick={() => handleShowTranscript(trans.transcript, trans.sessionid)}>
//                                                         Show Transcript
//                                                     </button>
//                                                 </td>
//                                             </tr>
//                                         ))
//                                     ) : (
//                                         <tr>
//                                             <td colSpan={4}>No transcript available.</td>
//                                         </tr>
//                                     )}
//                                 </tbody>
//                             </table>
//                         </div>
//                     </div>
//                 </div>

//                 {/* Modal for Transcript */}
//                 {showModal && (
//                     <div className="modal-overlay">
//                         <div className="modal-content">
//                             <div className="modal-header">
//                                 Session ID : {currentSessionid}
//                             </div>
//                             <button className="close-modal" onClick={handleCloseModal}>
//                                 &times; Close
//                             </button>
//                             <div className="modal-transcript">
//                                 <div
//                                     dangerouslySetInnerHTML={{
//                                         __html: formatTextWithBold(currentTranscript),
//                                     }}
//                                 />
//                             </div>
//                         </div>
//                     </div>
//                 )}
//                 <div style={{ height: "100px" }}></div>
//                 <footer>
//                     <div className="footer-content">
//                         <p></p>
//                     </div>
//                 </footer>
//             </div>
//         </>
//     );
// };

// export default TransDash;


import React, { useState, useEffect } from 'react';
import './Transcript.css';

const TransDash = () => {
    const [startDate, setStartDate] = useState('');
    const [endDate, setEndDate] = useState('');
    const [transcriptdata, setTranscriptData] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [submittedRange, setSubmittedRange] = useState(null);
    const [showModal, setShowModal] = useState(false);
    const [currentTranscript, setCurrentTranscript] = useState('');
    const [currentSessionid, setCurrentSessionid] = useState('');
    const [emailFilter, setEmailFilter] = useState('All');
    const [uniqueEmails, setUniqueEmails] = useState([]);
    const [isDataFetched, setIsDataFetched] = useState(false);  // New state to track if data is fetched

    useEffect(() => {
        const handleScroll = () => {
            const footer = document.querySelector('footer');
            if ((window.innerHeight + window.scrollY) >= document.body.offsetHeight) {
                footer.style.display = 'block';
            } else {
                footer.style.display = 'none';
            }
        };

        window.addEventListener('scroll', handleScroll);
        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, []);

    useEffect(() => {
        if (startDate && endDate) {
            handleSubmitDateRange()
        }
    }, [startDate, endDate])


    const fetchFeedbackData = async (start, end) => {
        setIsLoading(true);
        try {
            const response = await fetch(`/api/feedback`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ start, end }),
            });
            const result = await response.json();
            setTranscriptData(result.transcript);
            const emails = result.transcript.map((trans) => trans.emailID);
            setUniqueEmails(['All', ...new Set(emails)]);
            setIsDataFetched(true); // Set the flag when data is fetched
        } catch (error) {
            console.error('Error fetching data:', error);
            setIsDataFetched(false); // If there's an error, reset the data flag
        } finally {
            setIsLoading(false);
        }
    };

    const formatTextWithBold = (text) => {
        const boldedText = text.replace(/\*\*(.*?)\*\*/g, (match, p1) => `<strong>${p1}</strong>`);
        const withParagraphs = boldedText.replace(/\n\n/g, '</p><p>');
        const formattedText = withParagraphs.replace(/\n/g, '<br />');
        return `<p>${formattedText}</p><br><br>`;
    };

    const handleSubmitDateRange = async () => {
        if (startDate && endDate) {
            setSubmittedRange(`${startDate} - ${endDate}`);
            fetchFeedbackData(startDate, endDate);
        } else {
            alert('Please select both start and end dates.');
        }
    };

    const handleShowTranscript = (transcript, sessionid) => {
        setCurrentTranscript(transcript);
        setCurrentSessionid(sessionid);
        setShowModal(true);
    };

    const handleCloseModal = () => {
        setShowModal(false);
    };

    // Filtered transcript data based on the email filter
    const filteredData = emailFilter === 'All'
        ? transcriptdata
        : transcriptdata.filter((trans) => trans.emailID === emailFilter);

    return (
        <>
            <h1 style={{ textAlign: "center" }}>Transcript Dashboard</h1>
            <div className="container">
                <div className="datepickercontainer">
                    <div className="date-picker">
                        <div className="startdate">
                            <label htmlFor="start-date-picker">Start date:</label>
                            <input
                                type="date"
                                id="start-date-picker"
                                name="start-date-picker"
                                value={startDate}
                                onChange={(e) => setStartDate(e.target.value)}
                            />
                        </div>
                        <div className="enddate">
                            <label htmlFor="end-date-picker">End date:</label>
                            <input
                                type="date"
                                id="end-date-picker"
                                name="end-date-picker"
                                value={endDate}
                                onChange={(e) => setEndDate(e.target.value)}
                            />
                        </div>
                    </div>
                    {/* <button onClick={handleSubmitDateRange}>Submit Date Range</button> */}
                </div>

                {/* Show email filter dropdown only if data is fetched */}
                {isDataFetched && (
                    <div className="email-filter">
                        <label htmlFor="email-filter">Filter by Email:</label>
                        <select
                            id="email-filter"
                            value={emailFilter}
                            onChange={(e) => setEmailFilter(e.target.value)}
                        >
                            {uniqueEmails.map((email, index) => (
                                <option key={index} value={email}>
                                    {email}
                                </option>
                            ))}
                        </select>
                    </div>
                )}

                {isLoading && <p>Loading...</p>}

                <div className="feedbacks">
                    <div className="feedbackscontents">
                        <h2>Transcript</h2>
                        {submittedRange && <p>{submittedRange}</p>}
                        <div className="table-container">
                            <table className="feedback-table">
                                <thead>
                                    <tr>
                                        <th>Date</th>
                                        <th>Username</th>
                                        <th>Email</th>
                                        <th>Transcript</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {filteredData.length > 0 ? (
                                        filteredData.map((trans, index) => (
                                            <tr key={index}>
                                                <td>{trans.date}</td>
                                                <td>{trans.name}</td>
                                                <td>{trans.emailID}</td>
                                                <td>
                                                    <button onClick={() => handleShowTranscript(trans.transcript, trans.sessionid)}>
                                                        Show Transcript
                                                    </button>
                                                </td>
                                            </tr>
                                        ))
                                    ) : (
                                        <tr>
                                            <td colSpan={4}>No transcript available.</td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>

                {/* Modal for Transcript */}
                {showModal && (
                    <div className="modal-overlay">
                        <div className="modal-content">
                            <div className="modal-header">
                                Session ID : {currentSessionid}
                            </div>
                            <button className="close-modal" onClick={handleCloseModal}>
                                &times; Close
                            </button>
                            <div className="modal-transcript">
                                <div
                                    dangerouslySetInnerHTML={{
                                        __html: formatTextWithBold(currentTranscript),
                                    }}
                                />
                            </div>
                        </div>
                    </div>
                )}

                <footer>
                    <div className="footer-content">
                        <p></p>
                    </div>
                </footer>
            </div>
        </>
    );
};

export default TransDash;
